<template>
  <div>
    <div class="basketball_team_scores" v-loading="loading">
      <dl class="team_unit_scores" v-show="homeScore.length > 0 && awayScore.length > 0">
        <dt>
          <strong>球队</strong>
          <span>一</span><span>二</span><span>三</span><span>四</span><span>加时</span><span>总分</span>
        </dt>
        <dd>
          <strong class="red">{{ matchInfo.home }}</strong>
          <span>{{ homeScore[0] }}</span>
          <span>{{ homeScore[1] }}</span>
          <span>{{ homeScore[2] }}</span>
          <span>{{ homeScore[3] }}</span>
          <span>{{ homeScore[4] }}</span>
          <span class="total">{{ totalScore.home }}</span>
        </dd>
        <dd>
          <strong class="blue">{{ matchInfo.away }}</strong>
          <span>{{ awayScore[0] }}</span>
          <span>{{ awayScore[1] }}</span>
          <span>{{ awayScore[2] }}</span>
          <span>{{ awayScore[3] }}</span>
          <span>{{ awayScore[4] }}</span>
          <span class="total">{{ totalScore.away }}</span>
        </dd>
      </dl>
      <div class="space_line" v-show="homeScore.length > 0 && awayScore.length > 0"></div>

      <template v-if="towTeamScore > 0">
        <dl class="score_compare">
          <dt>
            <p>本节犯规</p>
            <h3>{{ homeTeam.foul }}</h3>
          </dt>
          <dd>
            <div class="score_get_num">
              <span>{{ homeTeam.score3 }}</span>
              <strong>3分球得分</strong>
              <span>{{ awayTeam.score3 }}</span>
            </div>
            <div class="score_progress">
              <span :class="getColor(homeTeam.score3, awayTeam.score3)" :style="`width: ${getBigRate(homeTeam.score3, awayTeam.score3)}%`"></span>
            </div>
            <div class="score_get_num">
              <span>{{ homeTeam.score2 }}</span>
              <strong>2分球得分</strong>
              <span>{{ awayTeam.score2 }}</span>
            </div>
            <div class="score_progress">
              <span :class="getColor(homeTeam.score2, awayTeam.score2)" :style="`width: ${getBigRate(homeTeam.score2, awayTeam.score2)}%`"></span>
            </div>
          </dd>
          <dt>
            <p>本节犯规</p>
            <h3>{{ awayTeam.foul }}</h3>
          </dt>
        </dl>

        <dl class="score_compare">
          <dt>
            <p>剩余暂停</p>
            <h3>{{ homeTeam.surplus }}</h3>
          </dt>
          <dd>
            <div class="score_get_num">
              <span>{{ homeTeam.penalty }}</span>
              <strong>罚球得分</strong>
              <span>{{ awayTeam.penalty }}</span>
            </div>
            <div class="score_progress">
              <span :class="getColor(homeTeam.penalty, awayTeam.penalty)" :style="`width: ${getBigRate(homeTeam.penalty, awayTeam.penalty)}%`"></span>
            </div>
            <div class="score_get_num">
              <span>{{ homeTeam.penaltyRate }}</span>
              <strong>罚球命中率%</strong>
              <span>{{ awayTeam.penaltyRate }}</span>
            </div>
            <div class="score_progress">
              <span :class="getColor(homeTeam.penaltyRate, awayTeam.penaltyRate)" :style="`width: ${getBigRate(homeTeam.penaltyRate, awayTeam.penaltyRate)}%`"></span>
            </div>
          </dd>
          <dt>
            <p>剩余暂停</p>
            <h3>{{ awayTeam.surplus }}</h3>
          </dt>
        </dl>
      </template>

      <div v-if="towTeamScore == 0 && loading == false">
        <panel-not-data message="当前赛事暂无比分数据..." img-name="vs" />
      </div>
    </div>
  </div>
</template>

<script>
//引入公用无数据组件
import PanelNotData from "@/components/match-recommend/not-data";
export default {
  name: "BasketballScores",
  data() {
    return {
      loading: true,
      //主队得分
      homeScore: [],
      //客队得分
      awayScore: [],
      //球队总分
      totalScore: {},
      //主队情况
      homeTeam: {
        score3: 0,
        score2: 0,
        surplus: 0,
        penalty: 0,
        penaltyRate: 0,
        surplus: 0,
        foul: 0,
      },
      //客队情况
      awayTeam: {
        score3: 0,
        score2: 0,
        surplus: 0,
        penalty: 0,
        penaltyRate: 0,
        surplus: 0,
        foul: 0,
      },
      //两队中的各种分值是否全部为0，如果为空，则出现占位图
      towTeamScore: 0,
    };
  },
  components: {
    PanelNotData,
  },
  props: {
    matchInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    //增加强行关闭动画的定时器
    setTimeout(() => {
      this.loading = false;
    }, 20000);
  },
  methods: {
    /**
     * 处理接收到的数据，modify和received事件公用
     * @param {Object} ret_data 接收到的数据
     */
    runData(ret_data) {
      // console.log("球队比分内页接到的数据：",ret_data);
      if (ret_data.length > 2) {
        let data_list = JSON.parse(ret_data.replace(/[\\]+/g, "").slice(1, -1));
        // console.log("篮球球队比分数据：", data_list);
        if (data_list.length >= 1 && data_list[0].type == "scoreLive") {
          //处理得分
          let scores = data_list[0].basketball_scores;
          if (scores.home_score) {
            this.homeScore = scores.home_score;
          }
          if (scores.away_score) {
            this.awayScore = scores.away_score;
          }
          
          this.totalScore = {
            home: scores.home_total_score ? scores.home_total_score : 0,
            away: scores.away_total_score ? scores.away_total_score : 0,
          };
        }

        if (data_list.length == 2 && data_list[1].type == "statsLive") {
          //处理对比分
          let team_info = data_list[1].stats_live;
          // console.log("篮球球队比分数据1：", team_info);
          team_info.forEach((res) => {
            //只要有任何一个值大于0，则说明有统计数据
            if (res.type >= 1 && res.type <= 6 && (res.home > 0 || res.away > 0)) {
              this.towTeamScore++;
            }
            //3分球总得分
            if (res.type == 1) {
              this.$set(this.homeTeam, "score3", res.home);
              this.$set(this.awayTeam, "score3", res.away);
            }
            //2分球总得分
            if (res.type == 2) {
              this.$set(this.homeTeam, "score2", res.home);
              this.$set(this.awayTeam, "score2", res.away);
            }
            //罚球得分
            if (res.type == 3) {
              this.$set(this.homeTeam, "penalty", res.home);
              this.$set(this.awayTeam, "penalty", res.away);
            }
            //剩余暂停数
            if (res.type == 4) {
              this.$set(this.homeTeam, "surplus", res.home);
              this.$set(this.awayTeam, "surplus", res.away);
            }
            //犯规数
            if (res.type == 5) {
              this.$set(this.homeTeam, "foul", res.home);
              this.$set(this.awayTeam, "foul", res.away);
            }
            //罚球命中率
            if (res.type == 6) {
              this.$set(this.homeTeam, "penaltyRate", res.home);
              this.$set(this.awayTeam, "penaltyRate", res.away);
            }
          });
          // console.log("球队比分下半部分数据：", this.homeTeam, this.awayTeam);
        }
      }
      this.loading = false;
    },

    /**
     * 对比并获取样式名
     * @param {number} home 主队数值
     * @param {number} away 客队数值
     */
    getColor(home, away) {
      if (home == 0 && away == 0) {
        return "";
      }
      if (home > 0 && home >= away) {
        return "red";
      } else {
        return "blue";
      }
    },

    /**
     * 对比并获取样式名
     * @param {number} home 主队数值
     * @param {number} away 客队数值
     */
    getBigRate(home, away) {
      if (home == 0 && away == 0) {
        return 0;
      }
      if (home > 0 && home >= away) {
        return Math.round((home / (home + away)) * 100);
      } else {
        return Math.round((away / (home + away)) * 100);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
//[篮球-球队比分]对应的内容块
.basketball_team_scores {
  clear: both;
  width: 100%;
  min-height: 3.5rem;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0.2rem 0px;

  .space_line {
    clear: both;
    width: 100%;
    height: 1px;
    overflow: hidden;
    border-top: 1px solid #f0f0f0;
  }

  //篮球分节比分值汇总
  .team_unit_scores {
    clear: both;
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0.2rem 1.9rem;

    dt,
    dd {
      display: flex;
      justify-content: space-between;
      clear: both;
      width: 100%;
      height: 0.3rem;

      overflow: hidden;
      border-bottom: 1px solid #f0f0f0;
      font-size: 0.16rem;
      color: #999;
      text-align: center;
      font-weight: bold;

      strong {
        flex-shrink: 0;
        display: block;
        width: 1.6rem;
        height: 100%;
        overflow: hidden;
        box-sizing: border-box;
        text-align: left;
      }

      span {
        display: block;
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
    }

    dd {
      height: 0.4rem;
      line-height: 0.4rem;
      border-bottom: none;
      font-weight: 400;
      color: #333;

      strong {
        padding-left: 10px;
        position: relative;

        &::before {
          content: "";
          display: block;
          width: 2px;
          height: 16px;
          overflow: hidden;
          border-radius: 2px;
          position: absolute;
          z-index: 2;
          left: 0;
          top: 12px;
        }
      }

      strong.red {
        &::before {
          background-color: #f45b63;
        }
      }

      strong.blue {
        &::before {
          background-color: #4174f2;
        }
      }

      span.total {
        color: #db6372;
      }
    }
  }

  //红蓝队比较进度条内容块样式
  .score_compare {
    display: flex;
    justify-content: space-between;
    align-items: center;
    clear: both;
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0.2rem 1.9rem;

    dt {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 1.3rem;
      height: 100%;
      overflow: hidden;
      text-align: center;

      p,
      h3 {
        clear: both;
        width: 100%;
        height: 0.22rem;
        line-height: 0.22rem;
        overflow: hidden;
        font-size: 0.16rem;
        color: #333;
      }

      h3 {
        height: 0.38rem;
        line-height: 0.38rem;
        font-weight: 400;
        font-size: 0.2rem;
        color: #999;
      }

      &:first-child h3 {
        color: #ffba39;
      }
    }

    dd {
      width: 100%;
      height: 100%;
      overflow: hidden;
      box-sizing: border-box;
      padding: 0px 0.4rem;

      .score_get_num {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 0.32rem;
        overflow: hidden;
        font-size: 0.16rem;
        color: #333;

        strong {
          font-weight: 400;
        }
      }

      .score_progress {
        clear: both;
        width: 100%;
        height: 0.08rem;
        overflow: hidden;
        border-radius: 0.1rem;
        background-color: #dddfec;
        margin-bottom: 0.2rem;

        span {
          display: block;
          width: 0;
          height: 100%;
          overflow: hidden;
          border-radius: 0.1rem;
        }

        span.red {
          float: left;
          background-color: #f45b63;
        }

        span.blue {
          float: right;
          background-color: #4174f2;
        }
      }
    }
  }
}
</style>